import { useMemo, useEffect } from "react";
import { usePageState } from "../PageContext";
import { setIn, connect } from "formik";
import { isNotLiteral, isTouchyLiteralOrNotLiteral } from "../utils";
import { getFieldName } from "@ploy-lib/core";
import { usePages } from "../pagesContext";
import { useTemplateSectionIsVisible, useTemplateFieldIsVisible } from "../hooks";
export const TouchVisibleFieldsOnPreviousPages = connect(({ formik }) => {
    const pages = usePages();
    const { step } = usePageState();
    const previousPages = useMemo(() => pages.slice(0, step), [pages, step]);
    const fieldIsVisible = useTemplateFieldIsVisible();
    const sectionIsVisible = useTemplateSectionIsVisible();
    const { touched, setTouched } = formik;
    useEffect(() => setTouched(touchAllVisibleFields(touched, previousPages, fieldIsVisible, sectionIsVisible)), [fieldIsVisible, sectionIsVisible, previousPages, setTouched, touched]);
    return null;
});
export function touchAllVisibleFields(touched, pages, fieldIsVisible, sectionIsVisible, touchLiteral) {
    const paths = pages
        .flatMap(page => Object.values(page.panels))
        .filter(item => (touchLiteral ?? false) || isNotLiteral(item))
        .flatMap(panel => panel.sections || [])
        .filter(item => (touchLiteral ?? false) || isNotLiteral(item))
        .filter(sectionIsVisible)
        .flatMap(section => section.fields)
        .filter(item => (touchLiteral ?? false) || isTouchyLiteralOrNotLiteral(item))
        .filter(fieldIsVisible)
        .map(field => getFieldName(field));
    return paths.reduce((t, p) => setIn(t, p, true), touched);
}
//# sourceMappingURL=TouchVisibleFieldsOnPreviousPages.js.map